import React from 'react';
import styles from './Difference.module.scss';

const items = [
  { title: 'No Data Caps', description: 'Use what you need. When you need it.' },
  { title: 'Static IP Options', description: 'Built for security and remote access.' },
  { title: 'Custom Solutions', description: 'Tailored to your business needs.' },
  { title: 'Competitive Pricing', description: 'Maximum value. Built for your budget.' },
];

export const Difference = (): React.JSX.Element => {
  return (
    <section className={styles.difference}>
      <div className="grid-12">
        <div className={styles.container}>
          <p className={styles.eyebrow}>The Cityside Fiber Difference</p>
          <h2 className={styles.headline}>Reliable, business-ready service.</h2>
          <p className={styles.subtext}>Keep your team connected and operations moving.</p>

          <div className={styles.grid}>
            {items.map((item) => (
              <div key={item.title} className={styles.card}>
                <p className={styles.cardTitle}>{item.title}</p>
                <p className={styles.cardDescription}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
